export enum ETabType {
    Events = 'events',
    Calendar = 'calendar',
    Categories = 'categories',
}
